/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnshareQuoteTemplateFromStoreMutationVariables = Types.Exact<{
  input: Types.UnshareQuoteTemplateFromStoreInput;
}>;


export type UnshareQuoteTemplateFromStoreMutation = { unshareQuoteTemplateFromStore: { __typename: 'UnshareQuoteTemplateFromStoreInputResult', quoteTemplate: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean } | null } } };

export type QuoteTemplateUnshareFromStoreButton_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, hasSubscriptionToTemplate: boolean };

export const QuoteTemplateUnshareFromStoreButton_QuoteTemplateFragmentDoc = gql`
    fragment QuoteTemplateUnshareFromStoreButton_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  hasSubscriptionToTemplate
}
    `;
export const UnshareQuoteTemplateFromStoreDocument = gql`
    mutation UnshareQuoteTemplateFromStore($input: UnshareQuoteTemplateFromStoreInput!) {
  unshareQuoteTemplateFromStore(input: $input) {
    quoteTemplate {
      id
      resolvedAsReadModelVersionNumber
      templateSharing {
        id
        latestSharedVersionNumber
        sharedPublicly
      }
    }
  }
}
    `;
export type UnshareQuoteTemplateFromStoreMutationFn = Apollo.MutationFunction<UnshareQuoteTemplateFromStoreMutation, UnshareQuoteTemplateFromStoreMutationVariables>;

/**
 * __useUnshareQuoteTemplateFromStoreMutation__
 *
 * To run a mutation, you first call `useUnshareQuoteTemplateFromStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnshareQuoteTemplateFromStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unshareQuoteTemplateFromStoreMutation, { data, loading, error }] = useUnshareQuoteTemplateFromStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnshareQuoteTemplateFromStoreMutation(baseOptions?: Apollo.MutationHookOptions<UnshareQuoteTemplateFromStoreMutation, UnshareQuoteTemplateFromStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnshareQuoteTemplateFromStoreMutation, UnshareQuoteTemplateFromStoreMutationVariables>(UnshareQuoteTemplateFromStoreDocument, options);
      }
export type UnshareQuoteTemplateFromStoreMutationHookResult = ReturnType<typeof useUnshareQuoteTemplateFromStoreMutation>;
export type UnshareQuoteTemplateFromStoreMutationResult = Apollo.MutationResult<UnshareQuoteTemplateFromStoreMutation>;
export type UnshareQuoteTemplateFromStoreMutationOptions = Apollo.BaseMutationOptions<UnshareQuoteTemplateFromStoreMutation, UnshareQuoteTemplateFromStoreMutationVariables>;